<div class="w-100 h-100">
	<!-- No Agent -->
	<div *ngIf="dataLoaded && !data?.GraphTitle; else noDataError" class="error-message"
		cvLocalizedText langSection="Coaching_Effectiveness" langKey="No_Agent">
			No agent selected
	</div>

	<!-- No Data -->
	<ng-template #noDataError>
		<div *ngIf="dataLoaded && noData" class="error-message">
			{{noDataLocalization}}
		</div>
	</ng-template>

     <!-- Legend Tooltip -->
     <div #legendTooltip class="legend-tooltip" [hidden]="false"></div>

     <!-- Data -->
     <div class="mx-2" style="flex: 1 1 0px; min-width: 0px; height: 100%">
            <div *ngIf="dataLoaded && !noData" class="coaching-chart-area">
               <div class="coaching-chart">
                      <!-- ChartJS -->
                      <canvas baseChart *ngIf="chartConfig"
                          [type]="chartConfig.type"
                          [legend]="chartConfig.options.plugins?.legend"
                          [datasets]="chartConfig.data.datasets"
                          [labels]="chartConfig.data.labels"
                          [options]="chartConfig.options"
                          [plugins]="chartConfig.plugins"></canvas>
               </div>
            </div>
     </div>
</div>